import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { storage } from '../firebase-config'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import edit from '../assets/edit.png'

const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    position: 'relative',
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    maxWidth: '300px',
    margin: 'auto'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

export default function MyDropzone({ storageLocation, errors, name, editing, image, updateImage, allowAudio, allowVideo, allowPdf, allowImageAndPdf, customMessage, onUploadingChange }) {
    const [editingImage, setEditingImage] = useState(false)
    const [uploading, setUploading] = useState(false)
    const [uploadError, setUploadError] = useState('')

    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
        // console.log('acceptedFiles', acceptedFiles)

        const file = acceptedFiles[0]
        if (!file) return
        const extension = file.type.replace('image/', '').replace('application/', '').replace('video/', '')

        doUploadFile(file, extension)

    }, [])


    const doUploadFile = async (file, extension) => {
        const mountainsRef = ref(storage, `${storageLocation}.${extension}`);
        setUploading(true)
        setUploadError('')
        onUploadingChange?.(true)
        try {
            const snapshot = await uploadBytes(mountainsRef, file)
            const downloadURL = await getDownloadURL(snapshot.ref)
            updateImage(downloadURL)
            setEditingImage(false)
        } catch {
            setUploadError('Upload failed. Please try again.')
        } finally {
            setUploading(false)
            onUploadingChange?.(false)
        }
    }

    const isPdfFile = String(image || '').toLowerCase().includes('.pdf')

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: allowAudio
            ? { 'audio/*': [] }
            : allowVideo
                ? { 'video/*': [] }
                : allowImageAndPdf
                    ? { 'application/pdf': [], 'image/*': [] }
                    : allowPdf
                        ? { 'application/pdf': [] }
                        : { 'image/*': [] },
        onDrop
    });


    const style = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ])



    useEffect(() => {
        if (editing && !image && !editingImage) {
            setEditingImage(true)
        }
    }, [editing])


    useEffect(() => {
        if (errors.includes(name)) {
            document.getElementById(name).classList.add('errorImage')
        } else {
            document.getElementById(name).classList.remove('errorImage')
        }
    }, [errors])

    console.log('image', image)


    return (<div id={name} className="container" style={{ marginTop: '30px' }}>
        {uploadError && <p role="alert" style={{ color: 'red' }}>{uploadError}</p>}
        <div {...getRootProps({ style })}>
            {uploading ? <label>Uploading .... pls wait</label>
                : editingImage ?
                    <>
                        <input {...getInputProps()} />
                        <p>{customMessage || `Drop an image or click here to add one.`}</p>
                    </> :
                    allowAudio ? <>
                        <div>
                            {editing && <img src={edit} style={{ width: '20px', height: '20px', position: 'absolute', top: '10px', right: '10px' }} onClick={() => setEditingImage(true)} />}
                            <audio style={{ width: '100%', height: '100%' }} controls>
                                <source src={image} />
                            </audio>

                        </div>
                    </> : allowVideo ? <>
                        <div>
                            {editing && <img src={edit} style={{ width: '20px', height: '20px', position: 'absolute', top: '10px', right: '10px' }} onClick={() => setEditingImage(true)} />}
                            <video src={image} style={{ width: '100%', height: '100%' }} />

                        </div>
                    </> : (allowPdf || allowImageAndPdf) && isPdfFile ? <>
                        <div>
                            {editing && <img src={edit} style={{ width: '20px', height: '20px', position: 'absolute', top: '10px', right: '10px' }} onClick={() => setEditingImage(true)} />}
                            <label>PDF URL Generated!</label>
                        </div>

                    </> : <>
                        {editing && <img src={edit} style={{ width: '20px', height: '20px', position: 'absolute', top: '10px', right: '10px' }} onClick={() => setEditingImage(true)} />}
                        <img src={image} style={{ width: '100%', height: '100%' }} />
                    </>
            }
        </div>
    </div>)
}
